import React, {Component} from 'react';
import './GuestlistScreenCategory.css';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';

export default class GuestlistScreenCategory extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        if (!this.props.guestEntries) {
            return (null);
        }

        return (
            <div className={"GuestlistScreenCategory"}>
                <div className={"GuestlistScreenCategory__title"}>
                    <span>{this.props.categoryName}</span>
                    <span className={"GuestlistScreenCategory__title-count"}>
                        {this.props.guestEntries.length} {(!this.props.isSearching && (this.props.guestEntries.length !== 1 ? "genodigden" : "genodigde")) || ""} {(this.props.isSearching && ((this.props.guestEntries.length === 1 ? "resultaat" : "resultaten") + " in groep")) || ""}
                        </span>
                </div>
                <div className={"GuestlistScreenCategory__inner"}>
                    {this.props.guestEntries.map((guest) => {
                        return (
                            <Link key={`g${guest.id}`} className={"GuestlistScreenCategory__guest"}
                                  title={`${guest.name_first} ${guest.name_last}`}
                                  to={`/gasten/${guest.id}`}>
                                <i className={"mdi mdi-account-outline"}/>
                                <span>{guest.name_first} {guest.name_last}</span>
                            </Link>
                        );
                    })}
                </div>
            </div>
        );
    }
};

GuestlistScreenCategory.propTypes = {
    categoryName: PropTypes.string.isRequired,
    guestEntries: PropTypes.array.isRequired,
    isSearching: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/Portal/Guestlist/GuestlistScreenCategory.js